<template>
    <div class="top-header-area">
      <div class="container">
        <div class="row align-items-center">
          <div class="text-carousel-offer">
            <div class="carousel-content-offer">
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_implant') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_allx') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_hs') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_veneers') }}</span></router-link>
              <!-- Duplicate the content to create a seamless loop -->
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_implant') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_allx') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_hs') }}</span></router-link>
              <router-link to="/pricing"><span>{{ $t('top_bar_offer_veneers') }}</span></router-link>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TopOffersHeader',
    mounted() {
      const carousel = this.$el.querySelector('.carousel-content-offer');
      const spans = carousel.querySelectorAll('span');
      let interactionOccurred = false; 
  
      spans.forEach(span => {
        span.addEventListener('mouseenter', () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'paused';
          }
        });
        span.addEventListener('mouseleave', () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'running';
          }
        });
  
        span.addEventListener('touchstart', () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'paused';
          }
        });
        span.addEventListener('touchend', () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'running';
          }
        });
  
        span.addEventListener('click', () => {
          carousel.style.animationPlayState = 'running';
          interactionOccurred = true; 
          span.removeEventListener('mouseenter', pauseAnimation);
          span.removeEventListener('mouseleave', resumeAnimation);
          span.removeEventListener('touchstart', pauseAnimation);
          span.removeEventListener('touchend', resumeAnimation);
        });
  
        const pauseAnimation = () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'paused';
          }
        };
  
        const resumeAnimation = () => {
          if (!interactionOccurred) {
            carousel.style.animationPlayState = 'running';
          }
        };
      });
    }
  }
  </script>
  